(function () {
	"use strict";

	function Obstacle(world, x, y, container, sprite)
	{
		this.Container_constructor();
		this.mainView = null;
		this.allowUserControl = false;
		this.targetY = -1;
		this.world = world;
		this.invincibleTimer = 0;
		this.beginReset = false;
		this.ballX = 0;
		this.ballY = 0;
		this.tween = null;
		this.physicsData = {
			"sortObstacle": {
				"spriteRegX": 58.968,
				"spriteRegY": 57.96,
				"fixtures": [
					{
						"density": 2,
						"friction": 0,
						"restitution": 0,
						"categoryBits": 1,
						"maskBits": 65535,
						"groupIndex": 0,
						"isSensor": false,
						"userData": "",
						"fixtureType": "CIRCLE",
						"center": [0.032, -0.960],
						"radius": 56.886
					}
		]
			}
		};
		this.init(world, x, y, container, sprite);
	}

	var p = createjs.extend(Obstacle, cjs.Container);

	p.init = function (world, x, y, container, spriteObject)
	{

		var physicsData = this.physicsData.sortObstacle;
		var sprite = new cjs.Sprite(cm.Assets.lib.gameSS, spriteObject).center();
		sprite.snapToPixel = false;
		sprite.framerate = 24;
		sprite.x = x;
		sprite.y = y;
		sprite.scaleX = 0;
		sprite.scaleY = 0;
		var angle = Math.range(0,360);
		var rad = Math.toRad(angle);
		sprite.rotation = angle;
		this.displayObject = sprite;
		container.addChildAt(this.displayObject, 1);
		cjs.Tween.get(sprite).to({scaleX:1, scaleY:1}, 500, cjs.Ease.backOut);
		this.body = this.buildBodyFromData(physicsData, world, b2.b2Body.b2_staticBody, false);
		this.body.SetPosition(new b2.b2Vec2(x / b2.b2Scale, y / b2.b2Scale));
		this.body.SetAngle(rad);
		this.ballX = x;
		this.ballY = y;
	};

	p.bringToCenter = function (callback)
	{
		this.targetY = this.body.GetPosition().y * b2.b2Scale;
		cjs.Tween.get(this).to({ targetY: 0 }, 2000, cjs.Ease.quadOut).call(callback);
	};

	p.buildBodyFromData = function (data, world, bodyType, bool)
	{
		var fixtures = data.fixtures;
		var body;
		var bodyDef = new b2.b2BodyDef();
		bodyDef.type = bodyType;
		bodyDef.userData = this;
		if (bool)
			bodyDef.bullet = true;

		// create the body
		body = world.CreateBody(bodyDef);

		// prepare fixtures
		for (var i = 0; i < fixtures.length; i++) {
			var fixture = fixtures[i];
			var fixtureDef = new b2.b2FixtureDef();
			fixtureDef.density = fixture.density;
			fixtureDef.friction = fixture.friction;
			fixtureDef.restitution = fixture.restitution;
			fixtureDef.filter.categoryBits = fixture.categoryBits;
			fixtureDef.filter.maskBits = fixture.maskBits;
			fixtureDef.filter.groupIndex = fixture.groupIndex;
			fixtureDef.isSensor = fixture.isSensor;
			if (fixture.userData) fixtureDef.userData = fixture.userData;

			if (fixture.fixtureType === "POLYGON") {
				var polygons = fixture.polygons;
				for (var p = 0; p < polygons.length; p++) {
					var vertices = [];
					for (var m = 0; m < polygons[p].length; m++) {
						vertices.push(new b2.b2Vec2(polygons[p][m][0] / b2.b2Scale, polygons[p][m][1] / b2.b2Scale));
					}
					var polygonShape = new b2.b2PolygonShape();
					polygonShape.SetAsArray(vertices, vertices.length);
					fixtureDef.shape = polygonShape;

					body.CreateFixture(fixtureDef);
				}
			} else if (fixture.fixtureType === "CIRCLE") {
				var circleShape = new b2.b2CircleShape(fixture.radius / b2.b2Scale);
				circleShape.SetLocalPosition(new b2.b2Vec2(fixture.center[0] / b2.b2Scale, fixture.center[1] / b2.b2Scale));
				fixtureDef.shape = circleShape;
				body.CreateFixture(fixtureDef);
			}
		}

		return body;
	};

	p.update = function ()
	{
		var body, pos, vel, angle;
		if (this.allowUserControl) {
			body = this.body;
			pos = body.GetPosition();
			vel = body.GetLinearVelocity();
			angle = body.GetAngle();
			this.displayObject.x = pos.x * b2.b2Scale;
			this.displayObject.y = pos.y * b2.b2Scale;
			this.displayObject.rotation = Math.toDeg(angle);

		}

	};

	p.kill = function ()
	{
		this.allowUserControl = false;
		if(this.displayObject){
			cjs.Tween.get(this.displayObject)
			.to({scaleX:0, scaleY:0}, 500, cjs.Ease.backIn)
			.call(cm.ViewControl.current.removeChild, [this.displayObject], cm.ViewControl.current);
		}
		// cm.ViewControl.current.removeChild(this.displayObject);
		cm.ViewControl.current.projectile = null;

		this.displayObject = null;
		cjs.Tween.removeTweens(this);
		this.world.DestroyBody(this.body);
	};

	cm.Obstacle = cjs.promote(Obstacle, "Container");
})();